import type * as PageNotFound from '../types/PageNotFound'
import { imageParser } from '../props/parsers/Image'

export default function pageNotFoundComponentParser(
  rawComponent: PageNotFound.Raw,
): PageNotFound.Parsed {
  const { image, ...rest } = rawComponent.pageNotFound

  return {
    name: 'PageNotFound',
    props: {
      ...imageParser(image),
      ...rest,
    },
  }
}
